import { InfiniteScrolling } from "@Rocket-Innovation/components/shared/InfiniteScrolling";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

import { couponApi, historyApi } from "@api";
import {
    ArrowLeftColor,
    ComponentMenuBar,
    ComponentPopUpDone,
    CouponImage,
    IConClose,
    ModuleEmpty,
} from "@components";
import { enumStatus, enumTypes } from "@configs";
import { IMemberTier } from "@interfaces";
import { fetchUser, selectAuth, selectMerchant } from "@redux";
import { numberFormatter, RenderMeta } from "@utils";
import { Collapse, Tag } from "antd";
import { useEffect, useState } from "react";
import { formatDate } from "src/Utils/dateUtil";
import { HistoryEmptyIcon } from "./icon/HistoryEmptyIcon";
import { DisplayPoints } from "./shared/DisplayPoint";
const Panel = Collapse.Panel;

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentHistoryRedeem = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    //page props
    const { avatar, fullName, memberTier, isConfirm } = props;
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const themeColor = themes?.themeColor;
    const merchant = useSelector(selectMerchant);
    const today = new Date();

    const [isShowPopup, setShowPopup] = useState<boolean>(false);

    const [showpage1, setShowPage1] = useState(true);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(false);
    const [showpopuppage, setShowPopupPage] = useState(true);
    const [tab, setTab] = useState<number>(1);
    const [receiptList, setReceiptList] = useState<any[]>([]);
    const [historyList, setHistoryList] = useState<any[]>([]);
    const [pointList, setPointList] = useState<any[]>([]);
    const [goPointList, setGoPointList] = useState<any[]>([]);
    const [goReceiptList, setGoReceiptList] = useState<any[]>([]);
    const [currentHistory, setCurrentHistory] = useState<any>();
    const [showHistoryQr, setShowHistoryQr] = useState<boolean>(false);
    const [showRedeemCoupon, setShowRedeemCoupon] = useState<boolean>(false);
    const [showCouponDetail, setShowCouponDetail] = useState<boolean>(false);
    const prefix = window.location.hostname.split(".")[0];
    const [filterType, setFilterType] = useState<string>("REDEEMED");

    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        let queryParams = new URLSearchParams(window.location.search);
        let paramTab = queryParams.get("tab");
        if (paramTab === "points") {
            if (tab !== 1) {
                setPointList([]);
                setGoPointList([]);
                setTab(1);
                setPage(1);
            }
        } else if (paramTab === "redemptions") {
            if (tab !== 2) {
                setHistoryList([]);
                setTab(2);
                setPage(1);
            }
        } else if (paramTab === "upload") {
            if (tab !== 3) {
                setReceiptList([]);
                setTab(3);
                setPage(1);
            }
        }
    }, []);

    const getPointHistoryFromGo = async () => {
        let res = await historyApi.getPointHistoryFromGo({
            page: page,
            limit: 10,
        });
        if (res.data.data) {
            setGoPointList((prevData) => [...prevData, ...res.data.data]);
        }
    };

    const getUploadHistoryFromGo = async () => {
        let res = await historyApi.getUploadHistoryFromGo({
            user_id: userInfo?.contact?.userId,
            page: page,
            limit: 10,
        });
        if (res.data.data?.transactions) {
            setGoReceiptList((prevData) => [...prevData, ...res.data.data?.transactions]);
        }
    };

    // useEffect(() => {
    //     if (tab === 1) {
    //         tab1fetch();
    //     } else if (tab === 2) {
    //         tab2fetch();
    //     } else if (tab === 3) {
    //         tab3fetch();
    //     }
    // }, [tab]);

    const clickRedemption = (data: any) => {
        // click histroy item
        if (data?.type === "COUPON") {
            let arr = {
                ...data?.qrtable,
                ticketCode: data?.ticketCode,
                alienCode: data?.alienCode,
                notiStatus: data?.notiStatus,
            };
            setCurrentHistory(arr);
        } else {
            setCurrentHistory(data);
        }
        // if (data?.type === "COUPON" && data?.exchangedType === "RECEIVED") {
        //     setShowPopup(true);
        //     setShowPopupPage(true);
        //     setShowPage1(true);
        // } else {
        //     setShowHistoryQr(true);
        // }
        setShowHistoryQr(true);
    };

    const confirmRedeem = async () => {
        if (currentHistory?.type === "COUPON") {
            const res = await couponApi.redeemedCouponNotId(
                {
                    objectId: currentHistory?._id,
                    status: enumStatus.ACTIVE,
                    type: enumTypes.COUPON,
                },
                currentHistory?._id || ""
            );
        }
    };

    const handleRedeemedCoupon = async () => {
        await null;
    };

    const handleCloseDetail = () => {
        setShowPopup(false);
        closeAllPopup();
    };

    const closeAllPopup = () => {
        setShowPage1(true);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(true);
        dispatch(fetchUser());
    };

    useEffect(() => {
        if (tab === 1) {
            if (prefix !== "futurepark" && prefix !== "hamtest") {
                tab1fetch();
            } else {
                getPointHistoryFromGo();
            }
        } else if (tab === 2) {
            tab2fetch();
        } else if (tab === 3) {
            tab3fetch();
        } else if (tab === 4) {
            getUploadHistoryFromGo();
        }
    }, [tab, page, filterType]);

    const tab1fetch = async () => {
        try {
            setLoading(true);
            let res = await historyApi.getClientHistoryPoint(userInfo?.contact?.userId || "", {
                page: page,
                limit: 10,
            });
            if (res.data?.docs) {
                setPointList((prevData) => [...prevData, ...res.data.docs]);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }

        // setPointList(res.data?.docs);
    };

    const tab2fetch = async () => {
        let res = await historyApi.gethistories(filterType);
        setHistoryList(res.data);
    };

    const tab3fetch = async () => {
        let res = await historyApi.getReceiptUpload(userInfo?.contact?.userId || "");
        setReceiptList(res.data);
    };

    // console.log("historyList", historyList);
    // console.log("qrtable", historyList[0]?.endDate);

    return (
        <>
            <RenderMeta title={t("meta.historyredeem_page")} />
            <StyledHistoryRedeem themeColor={themes?.themeColor!}>
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            color={themes?.themeColor}
                            onClick={() => history.goBack()}
                        />
                        {/* <span>{t("page.back")}</span> */}
                    </div>
                    <h4>{t("page.history_redeem.title")}</h4>
                    <div className="logo-product">
                        {/* <img src="../images/logo-pet.svg" alt="" /> */}
                    </div>
                </header>
                <div className="tab-section">
                    {merchant?.securityConfig?.isPointDisplay === true && (
                        <div
                            className={"tab-item " + (tab === 1 ? "active" : "")}
                            onClick={() => {
                                if (tab !== 1) {
                                    setTab(1);
                                    setPage(1);
                                    setPointList([]);
                                    setGoPointList([]);
                                }
                            }}
                        >
                            {t("page.history_redeem.tab_point")}
                        </div>
                    )}
                    <div
                        className={"tab-item " + (tab === 2 ? "active" : "")}
                        onClick={() => {
                            if (tab !== 2) {
                                setTab(2);
                                setPage(1);
                                setHistoryList([]);
                            }
                        }}
                    >
                        {t("page.history_redeem.tab_redemp")}
                    </div>
                    <div
                        className={"tab-item " + (tab === 3 ? "active" : "")}
                        onClick={() => {
                            if (tab !== 3) {
                                setTab(3);
                                setPage(1);
                                setReceiptList([]);
                            }
                        }}
                    >
                        {t("page.history_redeem.tab_upload")}
                    </div>
                    {(prefix === "futurepark" || prefix === "hamtest") && (
                        <div
                            className={"tab-item " + (tab === 4 ? "active" : "")}
                            onClick={() => {
                                if (tab !== 4) {
                                    setTab(4);
                                    setPage(1);
                                    setGoReceiptList([]);
                                }
                            }}
                        >
                            Front line
                        </div>
                    )}
                </div>
                {tab === 2 && (
                    <StyledFilterByType>
                        <StyledBtnPurchases
                            themeColor={themeColor || ""}
                            isActive={filterType === "REDEEMED"}
                            onClick={() => setFilterType("REDEEMED")}
                        >
                            {t("page.redeem")}
                        </StyledBtnPurchases>
                        <StyledBtnPurchases
                            themeColor={themeColor || ""}
                            onClick={() => setFilterType("USED")}
                            isActive={filterType === "USED"}
                        >
                            {t("page.history_redeem.RESOLVED")}
                        </StyledBtnPurchases>
                        <StyledBtnPurchases
                            themeColor={themeColor || ""}
                            onClick={() => setFilterType("EXPIRED")}
                            isActive={filterType === "EXPIRED"}
                        >
                            {t("page.history_redeem.expired")}
                        </StyledBtnPurchases>
                    </StyledFilterByType>
                )}
                <div className="wrapper-history-redeem">
                    {merchant?.securityConfig?.isPointDisplay === true && (
                        <>
                            {tab === 1 && prefix !== "futurepark" && prefix !== "hamtest" && (
                                <InfiniteScrolling
                                    data={pointList}
                                    limit={10}
                                    page={page}
                                    setPage={setPage}
                                    loading={loading}
                                    themeColor={themes?.themeColor!}
                                    height="100vh"
                                    children={
                                        <div style={{ padding: 10 }}>
                                            <></>
                                            {pointList?.map((pItem: any, pIndex: number) => {
                                                if (
                                                    pItem?.type === "REVERTED" ||
                                                    pItem?.type === "EARNEDBYSYSTEM"
                                                )
                                                    return null;
                                                return (
                                                    <StyledContainerReward
                                                        key={pIndex}
                                                        themeColor={themes?.themeColor!}
                                                    >
                                                        <div className="img-layout">
                                                            <CouponImage
                                                                imageUrl="images/img-historyredeem-01.svg"
                                                                backgroundSize="56px"
                                                            />
                                                            <div className="used" />
                                                        </div>
                                                        <div className="body">
                                                            <div>
                                                                <div className="type">
                                                                    {t(
                                                                        "page.history_redeem.points"
                                                                    )}
                                                                </div>
                                                                <div className="title text-sub-header">
                                                                    {pItem?.type === "GIVEN"
                                                                        ? t(
                                                                              "page.history_redeem.gain_point"
                                                                          )
                                                                        : t(
                                                                              "page.history_redeem.use_point"
                                                                          )}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="date"
                                                                style={{
                                                                    margin: "3px 0 10px 0",
                                                                }}
                                                            >
                                                                <span
                                                                    className="time eng"
                                                                    style={{
                                                                        fontSize: 11,
                                                                    }}
                                                                >
                                                                    {`${t(
                                                                        "page.history_redeem.remark"
                                                                    )}: ${
                                                                        pItem?.remark ||
                                                                        pItem?.note ||
                                                                        ""
                                                                    }`}
                                                                </span>
                                                            </div>
                                                            <div className="date">
                                                                <span className="status">
                                                                    {pItem?.type === "GIVEN"
                                                                        ? t(
                                                                              "page.history_redeem.gain"
                                                                          )
                                                                        : t(
                                                                              "page.history_redeem.use"
                                                                          )}
                                                                </span>
                                                                <span className="time eng">
                                                                    {formatDate(pItem?.createdAt)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={
                                                                "quality " +
                                                                (pItem?.type === "GIVEN"
                                                                    ? "add"
                                                                    : "")
                                                            }
                                                        >
                                                            <DisplayPoints
                                                                suffix={`${
                                                                    pItem?.type === "GIVEN"
                                                                        ? "+"
                                                                        : "-"
                                                                }${pItem?.point}`}
                                                                enable={
                                                                    merchant?.securityConfig
                                                                        ?.isPointDisplay!
                                                                }
                                                            />
                                                        </div>
                                                    </StyledContainerReward>
                                                );
                                            })}
                                        </div>
                                    }
                                />
                            )}
                            {tab === 1 &&
                                pointList?.length === 0 &&
                                prefix !== "futurepark" &&
                                prefix !== "hamtest" && (
                                    <ModuleEmpty
                                        description={t("page.no_history")}
                                        image={<HistoryEmptyIcon />}
                                    />
                                )}
                            {tab === 1 && (prefix === "futurepark" || prefix === "hamtest") && (
                                <InfiniteScrolling
                                    data={goPointList}
                                    limit={10}
                                    page={page}
                                    setPage={setPage}
                                    loading={loading}
                                    themeColor={themes?.themeColor!}
                                    height="100vh"
                                    children={
                                        <div style={{ padding: 10 }}>
                                            {goPointList?.map((pItem: any, pIndex: number) => {
                                                if (
                                                    // pItem?.type === "REVERTED" ||
                                                    pItem?.type === "EARNEDBYSYSTEM"
                                                )
                                                    return null;
                                                return (
                                                    <StyledContainerReward
                                                        key={pIndex}
                                                        themeColor={themes?.themeColor!}
                                                        isHeightAuto={true}
                                                    >
                                                        <div className="img-layout">
                                                            <CouponImage
                                                                imageUrl="images/img-historyredeem-01.svg"
                                                                backgroundSize="56px"
                                                            />
                                                            <div className="used" />
                                                        </div>
                                                        <div className="body">
                                                            <div>
                                                                <div className="type">
                                                                    {t(
                                                                        "page.history_redeem.points"
                                                                    )}
                                                                </div>
                                                                <div className="title text-sub-header">
                                                                    {pItem?.type === "GIVEN" ||
                                                                    pItem?.type === "EARNED"
                                                                        ? t(
                                                                              "page.history_redeem.gain_point"
                                                                          )
                                                                        : pItem?.type === "REPLACED"
                                                                        ? t(
                                                                              "page.history_redeem.REPLACED"
                                                                          )
                                                                        : pItem?.type === "REVERTED"
                                                                        ? t(
                                                                              "page.history_redeem.reverse_point"
                                                                          )
                                                                        : t(
                                                                              "page.history_redeem.use_point"
                                                                          )}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="dates"
                                                                style={{ margin: "3px 0 10px 0" }}
                                                            >
                                                                <span
                                                                    className="time eng"
                                                                    style={{ fontSize: 11 }}
                                                                >
                                                                    {`${t(
                                                                        "page.history_redeem.remark"
                                                                    )}: ${
                                                                        pItem?.remark ||
                                                                        pItem?.note ||
                                                                        ""
                                                                    }`}
                                                                </span>
                                                            </div>

                                                            <div className="date">
                                                                {/* <span className="status">
                                                                    {pItem?.type === "GIVEN" ||
                                                                    pItem?.type === "EARNED"
                                                                        ? t(
                                                                              "page.history_redeem.gain"
                                                                          )
                                                                        : t(
                                                                              "page.history_redeem.use"
                                                                          )}
                                                                </span> */}

                                                                <span className="time eng">
                                                                    {formatDate(pItem?.created_at)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={
                                                                "quality " +
                                                                (pItem?.type === "GIVEN" ||
                                                                pItem?.type === "EARNED"
                                                                    ? "add"
                                                                    : "")
                                                            }
                                                        >
                                                            <DisplayPoints
                                                                suffix={`${
                                                                    pItem?.type === "GIVEN" ||
                                                                    pItem?.type === "EARNED"
                                                                        ? "+"
                                                                        : pItem?.type === "REPLACED"
                                                                        ? " "
                                                                        : "-"
                                                                }${
                                                                    pItem?.summary_point
                                                                        ?.toString()
                                                                        ?.includes(".")
                                                                        ? numberFormatter(
                                                                              Number(
                                                                                  pItem?.summary_point
                                                                              ).toFixed(2)
                                                                          )
                                                                        : numberFormatter(
                                                                              Number(
                                                                                  pItem?.summary_point
                                                                              ).toFixed(0)
                                                                          )
                                                                }`}
                                                                enable={
                                                                    merchant?.securityConfig
                                                                        ?.isPointDisplay!
                                                                }
                                                            />
                                                        </div>
                                                    </StyledContainerReward>
                                                );
                                            })}
                                        </div>
                                    }
                                />
                            )}
                            {tab === 1 &&
                                goPointList?.length === 0 &&
                                (prefix === "futurepark" || prefix === "hamtest") && (
                                    <ModuleEmpty
                                        description={t("page.no_history")}
                                        image={<HistoryEmptyIcon />}
                                    />
                                )}
                        </>
                    )}
                    {tab === 2 &&
                        historyList?.map((hItem: any, hIndex: number) => {
                            let expireDate =
                                hItem?.type === "COUPON"
                                    ? new Date(hItem?.qrtable?.endDate)
                                    : new Date(hItem?.endDate);
                            const isExpired = expireDate && expireDate < today;
                            if (hItem?.type === "COUPON" && hItem?.notiStatus === undefined) {
                                return null;
                            }
                            return (
                                <StyledContainerReward
                                    themeColor={themes?.themeColor!}
                                    key={hIndex}
                                    onClick={() => clickRedemption(hItem)}
                                >
                                    <div className="img-layout">
                                        <CouponImage
                                            imageUrl={
                                                (hItem?.type === "COUPON"
                                                    ? hItem?.qrtable?.imageUrl?.[0]
                                                    : hItem?.imageUrl?.[0]) ||
                                                "images/img-historyredeem-02.svg"
                                            }
                                            grayScale={
                                                hItem?.notiStatus !== "RESOLVED"
                                                    ? isExpired
                                                        ? true
                                                        : false
                                                    : true
                                            }
                                        />
                                        <div className="used" />
                                    </div>
                                    <div className="body">
                                        <div>
                                            <div className="type">
                                                {t("page.history_redeem." + hItem?.type)}
                                            </div>
                                            <div className="title text-sub-header">
                                                {hItem?.type === "COUPON"
                                                    ? hItem?.qrtable?.name
                                                    : hItem?.name}
                                            </div>
                                        </div>
                                        <div className="date">
                                            <span className="status by">
                                                {/* {hItem?.notiStatus !== "RESOLVED"
                                                    ? isExpired
                                                        ? t("page.history_redeem.expired")
                                                        : t(
                                                              "page.history_redeem." +
                                                                  hItem?.notiStatus
                                                          )
                                                    : t("page.history_redeem." + hItem?.notiStatus)}  */}
                                                T&C
                                            </span>
                                            <span className="time eng">
                                                {/* {hItem?.notiStatus !== "RESOLVED"
                                                    ? isExpired
                                                        ? `${t("page.history_redeem.expired")}`
                                                        : `${t(("page.history_redeem." + hItem?.notiStatus))} ${formatDate(hItem?.qrtable?.endDate)}`
                                                    : t("page.history_redeem." + hItem?.notiStatus)
                                                } */}
                                                {hItem?.notiStatus !== "RESOLVED"
                                                    ? isExpired
                                                        ? `EXP : ${formatDate(hItem?.endDate)}`
                                                        : `Redeemed : ${formatDate(
                                                              hItem?.createdAt
                                                          )}`
                                                    : `Used : ${formatDate(hItem?.updatedAt)}`}
                                                {hItem?.notiStatus !== "RESOLVED" ? (
                                                    isExpired ? (
                                                        <span className="absolute expireDate">
                                                            Expire
                                                        </span>
                                                    ) : (
                                                        <span className="absolute leftDate">
                                                            Left{" "}
                                                            {Math.ceil(
                                                                (new Date(
                                                                    hItem?.type === "COUPON"
                                                                        ? hItem?.qrtable?.endDate
                                                                        : hItem?.endDate
                                                                ).getTime() -
                                                                    new Date().getTime()) /
                                                                    (1000 * 3600 * 24)
                                                            )}{" "}
                                                            days
                                                        </span>
                                                    )
                                                ) : (
                                                    ""
                                                )}
                                                {/* {t("page.history_redeem.expired")} :{" "} */}
                                                {/* {hItem?.type === "COUPON"
                                                    ? formatDate(hItem?.qrtable?.endDate)
                                                    : formatDate(hItem?.endDate)} */}
                                                {/* {hItem?.type === "COUPON" &&
                                                    formatDate(hItem?.qrtable?.endDate)} */}
                                            </span>
                                        </div>
                                    </div>
                                    {!isExpired && (
                                        <div
                                            className={
                                                hItem?.notiStatus !== "RESOLVED"
                                                    ? isExpired
                                                        ? "quality"
                                                        : "quality"
                                                    : "quality"
                                            }
                                        >
                                            <StyledBtnPurchases
                                                themeColor={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? "gray"
                                                            : themeColor
                                                        : themeColor
                                                }
                                                isActive={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? false
                                                            : true
                                                        : true
                                                }
                                                className={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? "display-none"
                                                            : ""
                                                        : "disable-btn"
                                                }
                                                disabled={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? true
                                                            : false
                                                        : true
                                                }
                                            >
                                                {hItem?.notiStatus !== "RESOLVED"
                                                    ? isExpired
                                                        ? t("page.history_redeem.expired")
                                                        : t(
                                                              "page.history_redeem." +
                                                                  hItem?.notiStatus +
                                                                  "_next"
                                                          )
                                                    : t(
                                                          "page.history_redeem." +
                                                              hItem?.notiStatus +
                                                              "_next"
                                                      )}
                                                {/* {t("page.history_redeem." + hItem?.notiStatus + "_next")} */}
                                            </StyledBtnPurchases>
                                        </div>
                                    )}
                                </StyledContainerReward>
                            );
                        })}
                    {tab === 2 && historyList?.length === 0 && (
                        <ModuleEmpty
                            description={t("page.no_history")}
                            image={<HistoryEmptyIcon />}
                        />
                    )}
                    {tab === 3 &&
                        receiptList?.map((rItem: any, rIndex: number) => {
                            return (
                                <StyledContainerReward
                                    key={rIndex}
                                    themeColor={themes?.themeColor!}
                                >
                                    <div className="img-layout">
                                        <CouponImage
                                            imageUrl={
                                                rItem?.imageUrl?.[0] ||
                                                "images/img-historyredeem-03.svg"
                                            }
                                        />
                                        <div className="used" />
                                    </div>
                                    <div className="body">
                                        <div>
                                            <div className="type">{t("page.upload")}</div>
                                            <div className="title text-sub-header">
                                                {t("page.history_receipt")}
                                            </div>
                                        </div>
                                        <div className="date">
                                            <span className={"status " + `${rItem?.status}`}>
                                                {t("page." + rItem?.status)}
                                            </span>
                                            <span className="time eng">
                                                {t("page.upload")}: {formatDate(rItem?.createdAt)}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="quality"></div>
                                </StyledContainerReward>
                            );
                        })}
                    {tab === 3 && receiptList?.length === 0 && (
                        <ModuleEmpty
                            description={t("page.no_history")}
                            image={<HistoryEmptyIcon />}
                        />
                    )}
                    {tab === 4 && (
                        <Collapse bordered={false} defaultActiveKey={["1"]}>
                            {goReceiptList?.map((rItem: any, rIndex: number) => {
                                return (
                                    <Panel
                                        header={
                                            <>
                                                {formatDate(rItem.receipt_date)}{" "}
                                                {rItem?.receipts?.every(
                                                    (item: any) => item?.is_cancelled === true
                                                ) ? (
                                                    <Tag color="red">
                                                        {t("page.history_redeem.cancel_receipt")}
                                                    </Tag>
                                                ) : (
                                                    ""
                                                )}{" "}
                                            </>
                                        }
                                        key={rIndex}
                                    >
                                        {rItem?.receipts &&
                                            Array.isArray(rItem?.receipts) &&
                                            rItem?.receipts?.map(
                                                (listItem: any, listIndex: number) => {
                                                    return (
                                                        <StyledContainerReward
                                                            key={listIndex}
                                                            themeColor={themes?.themeColor!}
                                                        >
                                                            <div className="img-layout">
                                                                <CouponImage
                                                                    imageUrl={
                                                                        listItem
                                                                            ?.receipt_image_urls?.[0] ||
                                                                        "images/img-historyredeem-03.svg"
                                                                    }
                                                                />
                                                                <div className="used" />
                                                            </div>
                                                            <div className="body">
                                                                <div>
                                                                    <div className="type">
                                                                        {t("page.upload")}
                                                                    </div>
                                                                    <div className="title text-sub-header">
                                                                        {t("page.history_receipt")}{" "}
                                                                        {listItem?.is_cancelled && (
                                                                            <Tag color="red">
                                                                                {t(
                                                                                    "page.history_redeem.cancel_receipt"
                                                                                )}
                                                                            </Tag>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="date">
                                                                    {/* <span
                                                                        className={
                                                                            "status " +
                                                                            `${rItem?.status}`
                                                                        }
                                                                    >
                                                                        {t("page." + rItem?.status)}
                                                                    </span> */}
                                                                    <span className="time eng">
                                                                        {t("page.upload")}:{" "}
                                                                        {formatDate(
                                                                            listItem?.created_at
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="quality"></div>
                                                        </StyledContainerReward>
                                                    );
                                                }
                                            )}
                                    </Panel>
                                );
                            })}
                        </Collapse>
                    )}
                    {/* <StlyedHistoryPurchases themeColor={themes?.themeColor!}>
                        <div className="title-purchases">
                            <h2>Starbuck Eakmai</h2>
                            <span>20/09/2023 12:20</span>
                        </div>
                        <div className="layout-purchases">
                            <div className="box-purchases">
                                <div className="detail-box-purchases">
                                    <div className="img-purchases">
                                        <img src="../images/img-purchases-01.png" alt="" />
                                    </div>
                                    <h4>BLACKPINK Strawberry Choco Cream Frappuccino®</h4>
                                    <p>Lorem ipsum is placeholder text commonly</p>
                                </div>
                                <div className="pride-purchases">
                                    <h4>159<span>฿</span></h4>
                                    <h5>x1</h5>
                                </div>
                            </div>
                            <div className="box-purchases">
                                <div className="detail-box-purchases">
                                    <div className="img-purchases">
                                        <img src="../images/img-purchases-02.png" alt="" />
                                    </div>
                                    <h4>Starbucks® Voyage Blend™ 2023</h4>
                                    <p>Lorem ipsum is placeholder text commonly</p>
                                </div>
                                <div className="pride-purchases">
                                    <h4>202<span>฿</span></h4>
                                    <h5>x1</h5>
                                </div>
                            </div>
                        </div>
                        <div className="layout-btn-purchases">
                            <StyledBtnPurchases
                                className="btn-redeem"
                                themeColor={themes?.themeColor!}
                            >
                                See Receipt
                            </StyledBtnPurchases>
                        </div>
                    </StlyedHistoryPurchases>
                    <StlyedDetailReceipt themeColor={themes?.themeColor!}>
                        <div className="title-purchases">
                            <h2>Starbuck Eakmai</h2>
                            <span>20/09/2023 12:20</span>
                        </div>
                        <div className="layout-purchases">
                            <div className="box-purchases">
                                <div className="detail-box-purchases">
                                    <div className="img-purchases">
                                        <img src="../images/img-purchases-01.png" alt="" />
                                    </div>
                                    <h4>BLACKPINK Strawberry Choco Cream Frappuccino®</h4>
                                    <p>Lorem ipsum is placeholder text commonly</p>
                                </div>
                                <div className="pride-purchases">
                                    <h4>159<span>฿</span></h4>
                                    <h5>x1</h5>
                                </div>
                            </div>
                            <div className="box-purchases">
                                <div className="detail-box-purchases">
                                    <div className="img-purchases">
                                        <img src="../images/img-purchases-02.png" alt="" />
                                    </div>
                                    <h4>Starbucks® Voyage Blend™ 2023</h4>
                                    <p>Lorem ipsum is placeholder text commonly</p>
                                </div>
                                <div className="pride-purchases">
                                    <h4>202<span>฿</span></h4>
                                    <h5>x1</h5>
                                </div>
                            </div>
                        </div>
                        <div className="layout-total-receipt">
                            <div className="box-total-receipt">
                                <div className="title-receipt">ราคารวม (2 รายการ)</div>
                                <div className="pride-receipt">361<span>฿</span></div>
                            </div>
                            <div className="box-total-receipt">
                                <div className="title-receipt">ส่วนลดคูปอง</div>
                                <div className="pride-receipt">-10<span>฿</span></div>
                            </div>
                            <div className="box-total-receipt">
                                <div className="title-receipt">VAT 7%</div>
                                <div className="pride-receipt">25.27<span>฿</span></div>
                            </div>
                            <div className="box-total-receipt all">
                                <div className="title-receipt">ราคาสุทธิ</div>
                                <div className="pride-receipt">335.73<span>฿</span></div>
                            </div>
                        </div>
                    </StlyedDetailReceipt> */}
                </div>
                <ComponentMenuBar />
            </StyledHistoryRedeem>
            {showHistoryQr && (
                <ComponentPopUpDone
                    handleCloseDetail={() => setShowHistoryQr(false)}
                    data={currentHistory}
                />
            )}
            {isShowPopup && (
                <StyledShowPopup themeColor={themes?.themeColor!}>
                    <div className="page-wrapper">
                        <div className="close" onClick={handleCloseDetail}>
                            <IConClose width={16} />
                        </div>
                        {showpopuppage ? (
                            <div className="content-layout">
                                <div className="content">
                                    {showpage1 ? (
                                        <>
                                            <div className="header-product">
                                                <div className="layout-img">
                                                    <div className="img-product">
                                                        <img
                                                            src={
                                                                currentHistory?.imageUrl?.[0] ||
                                                                "../images/img-detail-mission.png"
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="topic-product">
                                                    {currentHistory?.name}
                                                </div>
                                                <div className="expier-product">
                                                    Limit Redeem :{" "}
                                                    {formatDate(currentHistory?.startDate)} -{" "}
                                                    {formatDate(currentHistory?.endDate)}
                                                </div>
                                            </div>
                                            {/* <div className="content-product">
                                                <div className="topic-detail">{t("page.conditions")}</div>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
                                            </div> */}
                                            <StyledUsedBtn
                                                className="btn-redeem"
                                                themeColor={themes?.themeColor!}
                                                // onClick={() => { setShowPage1(false); setShowPage4(true); setShowPopupPage(false); }}
                                                onClick={confirmRedeem}
                                            >
                                                {t("page.redeem")}
                                            </StyledUsedBtn>
                                        </>
                                    ) : null}

                                    {showresult ? (
                                        <>
                                            <div className="content-info">
                                                <div className="header-product">
                                                    <div className="layout-img">
                                                        <div className="img-product">
                                                            <img src="../images/img-sub-luckydraw.png" />
                                                        </div>
                                                    </div>
                                                    <div className="result-luckydraw">
                                                        <div className="result-img-luckydraw">
                                                            <img
                                                                src="../images/img-result-luckydraw.png"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="text-giftset">
                                                            <h2>Get Discount 100 THB</h2>
                                                            <p>EXP : 1 Feb - 30 Mar 2023</p>
                                                        </div>
                                                    </div>
                                                    <div className="content-product">
                                                        <div className="topic-detail">
                                                            {t("page.conditions")}
                                                        </div>
                                                        <p>
                                                            Lorem ipsum dolor sit amet, consectetur
                                                            adipiscing elit, sed do eiusmod tempor
                                                            incididunt ut labore et dolore magna
                                                            aliqua Lorem ipsum dolor sit amet,
                                                            consectetur adipiscing elit, sed do
                                                            eiusmod tempor incididunt ut labore et
                                                            dolore magna aliqua
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                        {showpage4 ? (
                            <StyledPopupRedeem themeColor={themes?.themeColor!}>
                                <div className="box-popupconfirm">
                                    <div className="img-popupconfirm">
                                        <img
                                            src={
                                                merchant?.themes?.basicThemeSetting?.iconGeneral[0]
                                                    ?.image
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div className="title">
                                        <div className="text-sub-header">
                                            {t("page.pleaseconfirm")}
                                        </div>
                                    </div>
                                    <div className="btn-popupconfirm">
                                        <StyledUsedBtn
                                            className="btn-cancel"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => {
                                                setShowPage4(false);
                                                setShowPage1(true);
                                                setShowPopupPage(true);
                                            }}
                                        >
                                            {t("page.cancel")}
                                        </StyledUsedBtn>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => {
                                                setShowPage4(false);
                                                setShowResult(true);
                                                setShowPopupPage(true);
                                            }}
                                        >
                                            {t("page.confirm")}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledPopupRedeem>
                        ) : null}
                    </div>
                </StyledShowPopup>
            )}
        </>
    );
};

const StlyedDetailReceipt = styled.div<{ themeColor: string }>`
    background-color: #fff;
    border-radius: 14px;
    padding: 10px 12px;
    margin-top: 30px;
    .title-purchases {
        display: flex;
        margin-bottom: 8px;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px dashed #e1e1e1;
        padding-bottom: 8px;
        h2 {
            color: #336c51;
            font-size: 14px;
            line-height: 17px;
            font-weight: 600;
            margin-bottom: 0px;
        }
        span {
            color: #9b9b9b;
            font-size: 12px;
        }
    }
    .layout-purchases {
        margin-bottom: 12px;
        .box-purchases {
            padding: 8px 0;
            display: flex;
            justify-content: space-around;
            .detail-box-purchases {
                position: relative;
                padding-left: 50px;
                width: 80%;
                .img-purchases {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 42px;
                    height: 42px;
                    border-radius: 9px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                h4 {
                    color: #000;
                    font-size: 14px;
                    line-height: 17px;
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                p {
                    color: #9b9b9b;
                    font-size: 11px;
                    line-height: 14px;
                    margin-bottom: 0;
                }
            }
            .pride-purchases {
                width: 20%;
                text-align: right;
                h4 {
                    margin-bottom: 0;
                    color: #336c51;
                    font-size: 14px;
                    line-height: 17px;
                    font-weight: 600;
                }
                h5 {
                    margin-bottom: 0;
                    color: #525257;
                    font-size: 12px;
                    line-height: 16px;
                }
            }
        }
    }
    .layout-btn-purchases {
        text-align: right;
    }
    .layout-total-receipt {
        border-top: 1px dashed #e1e1e1;
        padding-top: 8px;
        margin-top: 8px;
        .box-total-receipt {
            padding: 8px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title-receipt {
                color: #454545;
                font-size: 14px;
                line-height: 17px;
                font-weight: 400;
            }
            .pride-receipt {
                color: #454545;
                font-size: 14px;
                line-height: 17px;
                font-weight: 600;
            }
        }
        .all {
            .title-receipt {
                color: ${(p) => p.themeColor};
                font-size: 16px;
                line-height: 17px;
                font-weight: 600;
            }
            .pride-receipt {
                color: ${(p) => p.themeColor};
                font-size: 16px;
                line-height: 17px;
                font-weight: 600;
            }
        }
    }
`;

const StlyedHistoryPurchases = styled.div<{ themeColor: string }>`
    background-color: #fff;
    border-radius: 14px;
    padding: 10px 12px;
    .title-purchases {
        display: flex;
        margin-bottom: 8px;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px dashed #e1e1e1;
        padding-bottom: 8px;
        h2 {
            color: #336c51;
            font-size: 14px;
            line-height: 17px;
            font-weight: 600;
            margin-bottom: 0px;
        }
        span {
            color: #9b9b9b;
            font-size: 12px;
        }
    }
    .layout-purchases {
        margin-bottom: 12px;
        .box-purchases {
            padding: 8px 0;
            display: flex;
            justify-content: space-around;
            .detail-box-purchases {
                position: relative;
                padding-left: 50px;
                width: 80%;
                .img-purchases {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 42px;
                    height: 42px;
                    border-radius: 9px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                h4 {
                    color: #000;
                    font-size: 14px;
                    line-height: 17px;
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                p {
                    color: #9b9b9b;
                    font-size: 11px;
                    line-height: 14px;
                    margin-bottom: 0;
                }
            }
            .pride-purchases {
                width: 20%;
                text-align: right;
                h4 {
                    margin-bottom: 0;
                    color: #336c51;
                    font-size: 14px;
                    line-height: 17px;
                    font-weight: 600;
                }
                h5 {
                    margin-bottom: 0;
                    color: #525257;
                    font-size: 12px;
                    line-height: 16px;
                }
            }
        }
    }
    .layout-btn-purchases {
        text-align: right;
    }
`;
const StyledBtnPurchases = styled.button<{ themeColor?: string; isActive?: boolean }>`
    padding: 6px 12px;
    color: #000;
    border-radius: 8px;
    border: 0.5px solid #f0f0f0;
    cursor: pointer;
    font-size: 12px;
    line-height: 16px;
    background: ${(p) => (p.isActive ? p.themeColor : "")};
    color: ${(p) => (p.isActive ? "#fff" : p.theme.colors.color)};
    border: 0.5px solid ${(p) => (p.isActive ? p.themeColor : "#f0f0f0")};
    /* &:active {
    } */
`;

const StyledHistoryRedeem = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    padding: 15px 15px;
    height: 100vh;
    background-color: #f7f7f7;
    position: relative;
    .wrapper-history-redeem {
        height: calc(100% - 180px);
        overflow: scroll;
        .nodata {
            padding: 30px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            p {
                font-size: 16px;
                color: #a5a5a5;
                line-height: 18px;
                margin-bottom: 5px;
            }
        }
    }
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        display: flex;
        align-items: center;
        top: 17px;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        position: relative;
        .title-group {
            text-align: center;
        }
        .text-header {
            font-size: 16px;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .tab-section {
        display: flex;
        justify-content: center;
        margin-bottom: 40px;
        gap: 16px;
        .tab-item {
            cursor: pointer;
            font-weight: 600;
            font-size: 15px;
            color: #9b9b9b;
        }
        .active {
            color: ${(p) => p.themeColor};
            position: relative;
            &::after {
                content: "";
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                width: 50%;
                height: 4px; /* Adjust the thickness of the border as needed */
                background-color: ${(p) => p.themeColor};
                border-radius: 5px;
            }
        }
    }
`;

const StyledContainerReward = styled.div<{ themeColor: string; isHeightAuto?: boolean }>`
    display: flex;
    justify-content: space-between;
    background: ${(p) => p.theme.colors.card};
    cursor: pointer;
    border-radius: 15px;
    margin-bottom: 10px;
    /* height: 100px; */
    height: ${(p) => (p.isHeightAuto ? "auto" : "100px")};
    position: relative;
    p {
        margin: 0;
    }
    .status.by {
        color: #001cdb !important;
        font-weight: 600;
    }
    .absolute {
        position: absolute !important;
        top: -5px;
        border-radius: 5px;
        padding: 4px 8px;
        margin-left: 10px;
    }
    .expireDate {
        background-color: #cccccc;
        color: #919191;
    }
    .leftDate {
        background-color: #ffdddb;
        color: #eb4c3e;
    }
    .img-layout {
        flex: none;
        position: relative;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
        background-color: ${(p) => p.themeColor};
        overflow: hidden;
        display: flex;
        width: 90px;
        .status {
            padding: 4px 8px;
            background: #676767;
            border-radius: 4px;
            position: absolute;
            top: 3px;
            left: -9px;
            z-index: 1;
            color: #fff;
            &.active {
                background: #49c549;
            }
            span {
                font-weight: 500;
                font-size: 10px;
                line-height: 16px;
                text-align: right;
                /* background: ${(p) => p.theme.colors.card}; */
                background: transparent;
            }
        }

        .used {
            width: 100%;
            padding-top: 90px;
            position: absolute;
            top: 0;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
            background: ${(p) => p.theme.colors.card};
            opacity: 0.4;
            height: 100%;
        }
    }
    .body {
        flex: 3;
        padding: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .type {
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: #525257;
            margin-bottom: 5px;
        }
        .title {
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: ${(p) => p.theme.colors.color};
        }
        .date {
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 14px;
            color: #919191;
            white-space: nowrap;
            position: relative;
            span {
                position: relative;
                margin-right: 5px;
                padding-right: 5px;
                &:after {
                    content: "";
                    width: 1px;
                    height: 12px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    background-color: #919191;
                    transform: translateY(-50%);
                }
                &:last-child {
                    &:after {
                        display: none;
                        margin-right: 0;
                        padding-right: 0;
                    }
                }
            }
            .approve {
                color: #007e3a;
            }
            .reject {
                color: #d20006;
            }
        }
        .dates {
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 14px;
            color: #919191;
            white-space: pre-wrap;
            position: relative;
            span {
                position: relative;
                margin-right: 5px;
                padding-right: 5px;
                &:after {
                    content: "";
                    width: 1px;
                    height: 12px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    background-color: #919191;
                    transform: translateY(-50%);
                }
                &:last-child {
                    &:after {
                        display: none;
                        margin-right: 0;
                        padding-right: 0;
                    }
                }
            }
            .approve {
                color: #007e3a;
            }
            .reject {
                color: #d20006;
            }
        }
    }
    .hidebox {
        display: none;
    }
    .quality {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: end;
        padding: 12px;
        justify-content: space-between;
        border-top-right-radius: 14px;
        border-bottom-right-radius: 14px;
        overflow: hidden;
        p {
            margin: 0;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            text-align: right;
            color: #e53223;
            white-space: nowrap;
        }
        .disable-btn {
            background-color: #a9a9a9;
            border-color: #a9a9a9;
        }
        .hidebox {
            display: none;
        }
    }
    .add {
        p {
            color: #26c2a4;
        }
    }
`;

const StyledPopupRedeem = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: ${(p) => p.themeColor};
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
                font-weight: 600;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledShowPopup = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
            font-weight: 600;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
            font-weight: 600;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-top: -100px;
            padding-bottom: 20px;
            .result-luckydraw {
                padding: 12px;
                background-color: rgba(51, 108, 81, 0.08);
                border-radius: 12px;
                position: relative;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .result-img-luckydraw {
                    margin-right: 16px;
                    img {
                        width: 100px;
                        height: 100px;
                    }
                }
                .text-giftset {
                    h2 {
                        font-size: 18px;
                        line-height: 21px;
                        color: #000;
                        font-weight: 600;
                    }
                    p {
                        font-size: 12px;
                        line-height: 16px;
                        margin-bottom: 0;
                        color: #9b9b9b;
                    }
                }
            }
            .layout-img {
                text-align: center;
                .img-product {
                    width: 150px;
                    height: 150px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
            .process-product {
                max-width: 200px;
                margin: 10px auto;
                .ant-progress-inner {
                }
                .ant-progress-bg {
                    background-color: ${(p) => p.themeColor};
                }
            }
        }
        .content-product {
            padding: 16px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            // padding: 10px;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const StyledFilterByType = styled.div`
    display: flex;
    gap: 10px;
    padding: 0px 10px 20px 10px;
`;
